import React from 'react'

const DummyPage = () => {
  return (
    <div style={{alignContent: 'center'}}>This is a DummyPage</div>
  )
}

export default DummyPage